import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';


@Component({
    selector: 'level-setting-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class LevelFormDialogComponent implements OnInit {
  public formGroup: FormGroup = new FormGroup({
    level: new FormControl('', Validators.required),
    status: new FormControl(''),
    sort: new FormControl('')
  });
  action: string;
  dialogTitle;
  eventType;
  public img = {url: '', name: ''};
  public uploadedImg;
  public logo;

  constructor(
    public dialogRef: MatDialogRef<LevelFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.action = data.action;

    if (this.action === 'edit') {
      this.dialogTitle = 'level.edit';
      this.eventType = data.type;
    } else {
      this.dialogTitle = 'level.new';
    }
  }

  ngOnInit() {
    if (this.action === 'edit') {
      this.formGroup.patchValue(this.eventType);
      this.logo = this.eventType.badge;
    }
  }

  setImg(img) {
    this.uploadedImg = img;
  }
}
